export enum GoalStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Cancelled = 3
}

export enum MilestoneStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Cancelled = 3
}

export function getGoalStatusLabel(status: GoalStatus): string {
  switch (status) {
    case GoalStatus.NotStarted:
      return 'Not Started';
    case GoalStatus.InProgress:
      return 'In Progress';
    case GoalStatus.Completed:
      return 'Completed';
    case GoalStatus.Cancelled:
      return 'Cancelled';
    default:
      return 'Unknown';
  }
}

export function getGoalStatusColor(
  status: GoalStatus
): 'success' | 'primary' | 'warning' | 'error' {
  switch (status) {
    case GoalStatus.Completed:
      return 'success';
    case GoalStatus.InProgress:
      return 'primary';
    case GoalStatus.NotStarted:
      return 'warning';
    case GoalStatus.Cancelled:
      return 'error';
    default:
      return 'warning';
  }
}
